"use client";

import { SEASON_FAVICON_SRC, useSeasonSkinActive } from "@/lib/season-skin";

/**
 * 시즌 파비콘 (JCG-3694).
 *
 * 시즌 스킨이 적용돼 있을 때만 파비콘 링크를 더한다(React 19 가 `<head>` 로 올린다).
 * 서버 HTML 에는 넣지 않는다 — 검색엔진이 시즌 파비콘을 캐시해 시즌 뒤에도 검색 결과에 남지 않게 하기 위해서다.
 */
export default function SeasonFavicon() {
  const active = useSeasonSkinActive();
  if (!active || !SEASON_FAVICON_SRC) return null;
  return <link rel="icon" href={SEASON_FAVICON_SRC} type="image/png" />;
}
